 
<template>
  <div>
    <j-select-biz-component :width="1000" returnId v-bind="configs" v-on="$listeners" />
  </div>
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent/index.vue'

  export default {
    name: 'JSelectDeviceProcess',
    components: { JSelectBizComponent },
    props: ['value'],
    data () {
      return {
        settings: {
          name: '工艺类型',
          displayKey: 'processName',
          valueKey: 'id',
          returnKeys: ['id', 'processName'],
          listUrl: '/device/devProcess/list',
          queryParamCode: 'processName',
          queryParamText: '工艺名称',
          columns: [
            {
              title: '工艺名称',
              align: 'center',
              dataIndex: 'processName'
            },
            { title: '说明', dataIndex: 'description', align: 'center', width: '30%', widthRight: '70%' },
          ]
        }
      }
    },
    computed: {
      configs () {
        return Object.assign({ value: this.value }, this.settings, this.$attrs)
      }
    },
    methods: {
      addFunc () {
        
      }
    }
  }
</script>

<style lang="less" scoped></style>
